import type {
  InvestorListDTO,
  InvoiceTransactionDraftDTO,
  TransactionImportConfidenceLevel,
} from '@inversor-hub/types';
import type { ConfLevel, DraftFormState } from './types';

export const toConfLevel = (value?: TransactionImportConfidenceLevel): ConfLevel =>
  value === 'HIGH' ? 'high' : value === 'MEDIUM' ? 'med' : 'low';

export const investmentLabel = (investment: InvestorListDTO) =>
  investment.alias || investment.address;

export const investmentNameForDraft = (draft: InvoiceTransactionDraftDTO): string | null => {
  return draft.suggestedInvestment?.alias || draft.suggestedInvestment?.address || null;
};

export const formatReceived = (draft: InvoiceTransactionDraftDTO) => {
  const iso = draft.email?.receivedAt ?? draft.createdAt;
  return new Date(iso).toLocaleDateString('es-ES', { day: '2-digit', month: 'short' });
};

export const toFormState = (draft: InvoiceTransactionDraftDTO): DraftFormState => ({
  investmentId: draft.suggestedInvestmentId ?? '',
  type: draft.type,
  category: draft.category,
  concept: draft.concept ?? '',
  amount: draft.amount != null ? String(draft.amount) : '',
  date: draft.date ? draft.date.slice(0, 10) : '',
  paymentMethod: draft.paymentMethod ?? '',
});
